import { render, staticRenderFns } from "./SearchPolicy.vue?vue&type=template&id=7c1b90e6&"
import script from "./SearchPolicy.vue?vue&type=script&lang=js&"
export * from "./SearchPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports